import { render, staticRenderFns } from "./TopicTitle.vue?vue&type=template&id=68bdda32&scoped=true&"
import script from "./TopicTitle.vue?vue&type=script&lang=js&"
export * from "./TopicTitle.vue?vue&type=script&lang=js&"
import style0 from "./TopicTitle.vue?vue&type=style&index=0&id=68bdda32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bdda32",
  null
  
)

export default component.exports